//CSSをバンドル
import 'Src/scss/admission.scss'
//共通のJavaScriptを読み込み
import 'Src/js/utils/utils'



$('#popupBg-kaisoku').hide();
$('#popupBg-resson').hide();



$('.popup-kaisoku').on('click', function(){
  $('#popupBg-kaisoku').fadeIn(300);
});
$('.popupClose, .popupBg').on('click', function(){
  // $(this).fadeOut(300);
  $('#popupBg-kaisoku').fadeOut(300);
});



$('.popup-resson').on('click', function(){
  $('#popupBg-resson').fadeIn(300);
});
$('.popupClose, .popupBg').on('click', function(){
  // $(this).fadeOut(300);
  $('#popupBg-resson').fadeOut(300);
});
